<div class="container">
  <section
    class="messages-container"
    [class.rounded-bottom]="isSendHidden()"
    [class.without-margin]="isSendHidden()"
  >
    <div class="messages" [class.centered]="!comments()?.length">
      @if (!order()) {
        @for (i of shimmerArray; track $index) {
          <iw-shimmer
            count="1"
            [class.shimmer-self]="!($index % 2)"
            [class.shimmer-stranger]="$index % 2"
          />
        }
      } @else {
        @for (comment of comments(); track comment.id) {
          <iw-message
            [text]="comment.message"
            [self]="!!comment.userId"
            [createdAt]="comment.createdAt"
          />
        } @empty {
          <div class="empty">
            <fu-icon iconName="not-found" size="32" />
            <h3 class="empty-title">
              {{ "ordersHistory.details.messages.empty.title" | translate }}
            </h3>
            <p class="empty-description">
              {{
                (!isSendHidden()
                  ? "ordersHistory.details.messages.empty.message"
                  : "ordersHistory.details.messages.empty.messageSendDisabled"
                ) | translate
              }}
            </p>
          </div>
        }
      }
    </div>
    <div #bottom></div>
  </section>
  @if (!isSendHidden()) {
    <form
      class="controls-container rounded-bottom"
      [formGroup]="form"
      (submit)="send()"
    >
      <fu-simple-input
        class="field"
        autocomplete="off"
        [useOutlineLabel]="false"
        formControlName="comment"
        [placeholder]="
          'ordersHistory.details.messages.input.placeholder' | translate
        "
      />
      <iw-button
        size="m"
        class="btn"
        uiType="primary"
        (click)="send()"
        [disabled]="sendDisabled"
      >
        {{ "ordersHistory.details.messages.btn.send" | translate }}
      </iw-button>
    </form>
  }
</div>
